import { ReactComponent } from "/builds/mb/front/src/app/assets/images/calendar.svg?react";
import url from "/builds/mb/front/src/app/assets/images/calendar.svg?url";
export { ReactComponent };
export default url;
